const API_BASE_URL = '/authenticationFirewall';

export { API_BASE_URL };
